import { Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class PJKeys extends MainKeys {
    get place() {
        return Places.mcPj
    }
}

export default PJKeys
